import 'svgxuse';
import $ from 'jquery';
import Cookies from 'js-cookie';

import Analytics from '@/scripts/old/helpers/Analytics';
import OnLoadHelper from '@/scripts/old/helpers/OnLoadHelper';

import Choices from '@/scripts/old/modules-refactored/Choices';
import Countdowns from '@/scripts/old/modules-refactored/Countdowns';
import DateInputs from '@/scripts/old/modules-refactored/DateInputs';
import Fifa2018Games from '@/scripts/old/modules-refactored/Fifa2018Games';
import InlineCountdowns from '@/scripts/old/modules-refactored/InlineCountdowns';
import LangSwitchers from '@/scripts/old/modules-refactored/LangSwitchers';
import PhotoAttach from '@/scripts/old/modules-refactored/PhotoAttach';
import Roulettes from '@/scripts/old/modules-refactored/Roulettes';
import ScrollTo from '@/scripts/old/modules-refactored/ScrollTo';
import SocialShare from '@/scripts/old/modules-refactored/SocialShare';
import Spoilers from '@/scripts/old/modules-refactored/Spoilers';

// TODO: refactore:

import './dev';

import InputMask from './modules/InputMask';
import FormValidator from './modules/FormValidator';
import SocialShareOld from './modules/SocialShare';
import Spoiler from './modules/Spoiler';
import Spoiler2 from './modules/Spoiler2';
import Preloader from './modules/Preloader';
import LandingB2C from './modules/landings/B2C';
import LandingMomProgram from './modules/landings/MomProgram';
import Carousel from './modules/carousel';
import Carousel3d from './modules/carousel-3d';
import ContentPopup from './modules/content-popup';
import FilterGroup from './modules/filter-group';
import FileUpload from './modules/file-upload';
import InputCardNumber from './modules/input-card-number';
import InputNumber from './modules/input-number';
import InputRange from './modules/input-range';
import InputScale from './modules/input-scale';
import Map from './modules/map';
import Popup from './modules/popup';
import ProductGallery from './modules/product-gallery';
import ProductVars from './modules/product-vars';
import Tabs from './modules/tabs';
import Tooltip from './modules/tooltip';

window.$ = $;
window.jQuery = $;
window.Cookies = Cookies;

const App = new (function App() {
  this.Analytics = Analytics;

  // TODO: remove when all modules refactored
  this.oldModules = {
    InputMask,
    FormValidator,
    SocialShare: SocialShareOld,
    Spoiler,
    Spoiler2,
    Carousel,
    Carousel3d,
    ContentPopup,
    FileUpload,
    FilterGroup,
    InputCardNumber,
    InputNumber,
    InputRange,
    InputScale,
    Map,
    Popup,
    Preloader,
    ProductGallery,
    ProductVars,
    Tabs,
    Tooltip,
    LandingB2C,
    LandingMomProgram,
  };
  this.initModules = () => {
    Object.keys(this.oldModules).forEach((module) => {
      const fn = this.oldModules[module].initAll;
      if (fn && typeof fn === 'function') {
        fn();
      }
    });
  };

  this.modules = {
    Choices,
    Countdowns,
    DateInputs,
    Fifa2018Games,
    InlineCountdowns,
    LangSwitchers,
    PhotoAttach,
    Roulettes,
    ScrollTo,
    SocialShare,
    Spoilers,
  };

  this.pageControllers = {};

  this.currentController = null;

  const loopModules = (method, params) => {
    Object.keys(this.modules).forEach((module) => {
      if (typeof this.modules[module][method] === 'function') {
        this.modules[module][method](params);
      }
    });
  };

  const destroyController = () => {
    if (this.currentController) {
      if (typeof this.currentController.destroy === 'function') {
        this.currentController.destroy();
      } else {
        console.warn('Current page controller doesn\'t have a method \'destroy\'');
      }
    }
  };

  const updateController = () => {
    const pageAttr = document.body.getAttribute('data-page');

    if (pageAttr && pageAttr.length) {
      const Controller = this.pageControllers[pageAttr];

      if (Controller && this.currentController instanceof Controller) {
        if (typeof this.currentController.update === 'function') {
          this.currentController.update();
        }
        return;
      }

      destroyController();

      if (Controller) {
        this.currentController = new Controller();
      } else {
        console.warn(`No controller for page ${pageAttr}`);
      }

      return;
    }

    destroyController();
  };

  loopModules('register', this);

  this.update = () => {
    loopModules('update');
    updateController();
  };

  this.destroy = () => {
    loopModules('destroy');
    destroyController();
  };

  OnLoadHelper.run(() => {
    updateController();

    // TODO: remove after refactoring
    this.initModules();
    this.init = () => {
      this.initModules();
    };
  });
})();

window.App = App;

export default App;
